import { styled, SvgIcon } from '@mui/material';

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.primary.main : '#202A33',
}));

const CVALogo = () => {
  return (
    <StyledSvgIcon color="primary">
      <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
          <path
            id="Vector"
            d="M4.46772 1.35077C6.63387 1.05539 8.84925 0.9077 11.0646 0.9077C13.28 0.9077 15.4954 1.05539 17.6616 1.35077C19.68 1.59693 21.1077 3.27077 21.2062 5.24C20.8616 5.14154 20.5169 5.04308 20.1231 5.04308C18.6954 4.94462 17.2185 4.84616 15.7416 4.84616C14.2646 4.84616 12.7877 4.89539 11.36 5.04308C8.89849 5.24 7.12618 7.30769 7.12618 9.67077V14.1508C7.12618 15.9231 8.1108 17.5477 9.68618 18.2862L6.92926 21.0431C6.6831 21.2892 6.38771 21.3385 6.09233 21.1908C5.79694 21.0431 5.60002 20.7969 5.60002 20.4523V16.2677C5.20617 16.2677 4.86156 16.1692 4.46772 16.12C2.35079 15.8246 0.923096 14.0031 0.923096 11.9846V5.48616C0.923096 3.41846 2.40002 1.59693 4.46772 1.35077Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M15.7417 6.42155C14.314 6.42155 12.8863 6.47078 11.4586 6.61847C9.83396 6.76616 8.70166 8.09538 8.70166 9.67077V14.1508C8.70166 15.7262 9.88319 17.1046 11.5078 17.2031C12.7878 17.3015 14.117 17.3508 15.4463 17.3508L18.3509 20.2554C18.597 20.5015 18.8924 20.5508 19.1878 20.4031C19.4832 20.3046 19.6801 20.0092 19.6801 19.6646V17.1538C19.7786 17.1538 19.9263 17.1538 20.0247 17.1538C21.6494 17.0062 22.8309 15.6769 22.8309 14.1015V9.62155C22.8309 8.04616 21.6493 6.6677 20.074 6.56923C18.6463 6.47077 17.2678 6.37231 15.7909 6.37231L15.7417 6.42155Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </StyledSvgIcon>
  );
};

export default CVALogo;
